import { TicketStatus } from '../models/Ticket'
import { TicketRepository } from '../repositories/TicketRepository'

export function CreateTicketStatusCase(ticketRepository: TicketRepository) {
  return async function ({
    ticketId,
    status
  }: {
    ticketId: string
    status: TicketStatus
  }) {
    return await ticketRepository.createTicketStatus({ ticketId, status })
  }
}
